<template lang="pug">
    .kr-embedded-method-wrapper(ref="container" @click.stop="")
        .kr-loading-container(v-if="!isLoaded")
          .kr-loading-label {{ translate('loading_payment_method') }}
          KryptonLoadingAnimation
        component(v-if="loadPaymentMethod" v-show="isLoaded" :is="getComponent()" v-bind="{method: shortMethodKey}" @ready="onReady" class="kr-embedded-method")
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import EmbeddedCardForm from '@/host/components/smartform/embeddedMethod/EmbeddedCardForm'
import KryptonLoadingAnimation from '@/host/components/controls/KryptonLoadingAnimation'
import EmbeddedMethods from '@/configuration/sources/smartform/EmbeddedMethods.yml'

export default {
  name: 'EmbeddedMethod',
  components: {
    EmbeddedCardForm,
    KryptonLoadingAnimation
  },
  props: {
    method: {
      type: String,
      default: ''
    },
    extraMargin: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadPaymentMethod: false,
      isLoaded: false
    }
  },
  computed: {
    ...mapGetters(['getShortMethodKey', 'translate', 'activeEmbeddedMethod']),
    ...mapState({
      errorCode: state => state.error.errorCode
    }),
    isActive() {
      return this.activeEmbeddedMethod?.toString() === this.method
    },
    shortMethodKey() {
      return this.getShortMethodKey(this.method)
    }
  },
  watch: {
    async errorCode() {
      if (this.isActive) {
        await this.emitCurrentHeight()
      }
    },
    async isActive(newVal) {
      if (newVal) {
        this.loadPaymentMethod = true
        await this.emitCurrentHeight()
        if (this.isLoaded)
          this.$store.dispatch('openEmbeddedMethod', this.method)
      } else {
        this.$emit('height', 0)
      }
    }
  },
  async created() {
    if (this.isActive) {
      this.loadPaymentMethod = true
      await this.emitCurrentHeight()
    }
  },
  methods: {
    async onReady() {
      this.isLoaded = true

      if (this.isActive) {
        await this.$store.dispatch('openEmbeddedMethod', this.method)
        await this.emitCurrentHeight()
      }
    },
    async emitCurrentHeight() {
      await this.$nextTick()
      this.$emit(
        'height',
        this.$refs.container.getBoundingClientRect().height + this.extraMargin
      )
    },
    getComponent() {
      return EmbeddedMethods[this.shortMethodKey].component
    }
  }
}
</script>
